import { LG } from "../../styles/liquidGlass";

export const priceRowStyle = {
    display: "flex",
    justifyContent: "space-between",
};

export const priceLabelStyle = {
    fontFamily: "inherit",
    fontSize: "0.875rem",
    color: LG.color.textSecondary,
};

export const priceValueStyle = {
    fontFamily: "inherit",
    fontSize: "0.875rem",
    color: LG.color.text,
};

export const discountLabelStyle = {
    color: LG.color.textSecondary,
    fontSize: "0.875rem",
    mb: 1,
    fontFamily: "inherit",
    maxWidth: "70%",
};

export const discountValueStyle = {
    color: LG.color.textSecondary,
    fontSize: "0.875rem",
    fontFamily: "inherit",
};

export const totalLabelStyle = {
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    color: LG.color.text,
    fontSize: "1.25rem",
    fontWeight: 700,
    letterSpacing: "-0.02em",
};

export const totalValueStyle = {
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    color: LG.color.text,
    fontSize: "1.25rem",
    fontWeight: 700,
    letterSpacing: "-0.02em",
};

export const breadcrumbActiveStyle = {
    fontFamily: "inherit",
    fontSize: "0.8125rem",
    color: LG.color.text,
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
};

export const breadcrumbInactiveStyle = {
    fontFamily: "inherit",
    fontSize: "0.8125rem",
    color: LG.color.textSecondary,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
};

export const sectionTitleStyle = {
    fontFamily: "inherit",
    textAlign: "left",
    fontSize: "0.75rem",
    color: LG.color.textMuted,
    fontWeight: 700,
    mb: 1.5,
    mt: 1,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
};

export const checkboxStyle = {
    color: LG.color.text,
    "&.Mui-checked": { color: LG.color.text },
};

export const checkboxLabelStyle = {
    "& .MuiTypography-root": {
        fontFamily: "inherit",
        fontSize: "0.875rem",
        color: LG.color.textSecondary,
    },
};

export const textFieldStyle = {
    "& .MuiOutlinedInput-root": {
        borderRadius: LG.radius.xs,
        fontFamily: "inherit",
        fontSize: "0.875rem",
        background: "#ffffff",
        "& fieldset": { borderColor: "rgba(0, 0, 0, 0.18)" },
        "&:hover fieldset": { borderColor: "rgba(0, 0, 0, 0.36)" },
        "&.Mui-focused fieldset": { borderColor: LG.color.text, borderWidth: "1.5px" },
        "&.Mui-error fieldset": { borderColor: "#d32f2f", borderWidth: "1.5px" },
        "&.Mui-error": { backgroundColor: "rgba(211, 47, 47, 0.04)" },
    },
    "& .MuiInputLabel-root": {
        fontFamily: "inherit",
        fontSize: "0.875rem",
        color: "rgba(0, 0, 0, 0.72)",
        "&.Mui-focused": { color: LG.color.text },
        "&.Mui-error": { color: "#d32f2f" },
    },
    "& .MuiOutlinedInput-input": {
        color: LG.color.text,
        "&:-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 100px #ffffff inset",
            WebkitTextFillColor: LG.color.text,
            caretColor: LG.color.text,
        },
    },
};

export const zipCodeLinkStyle = {
    fontSize: "0.8125rem",
    fontFamily: "inherit",
    color: LG.color.textSecondary,
    textDecoration: "none",
    cursor: "pointer",
    whiteSpace: "nowrap",
    pr: 1,
    "&:hover": { color: LG.color.text },
};

export const continueButtonStyle = {
    background: LG.color.buttonDark,
    color: LG.color.buttonDarkText,
    borderRadius: LG.radius.pill,
    fontWeight: 500,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    fontSize: "0.8125rem",
    "&:hover": { background: LG.color.text, transform: "translateY(-1px)" },
};

export const productListStyle = {
    maxHeight: "300px",
    overflow: "auto",
    "&::-webkit-scrollbar": { width: "4px" },
    "&::-webkit-scrollbar-track": { background: "transparent" },
    "&::-webkit-scrollbar-thumb": {
        background: LG.color.border,
        borderRadius: "2px",
    },
};

export const productItemStyle = {
    display: "flex",
    justifyContent: "space-between",
    mb: 2,
    alignItems: "center",
};

export const productInfoStyle = {
    display: "flex",
    alignItems: "center",
    gap: 2,
};

export const productImageStyle = {
    width: 60,
    height: 80,
    objectFit: "cover",
    borderRadius: LG.radius.xs,
};

export const productNameStyle = {
    fontFamily: "inherit",
    fontSize: "0.875rem",
    color: LG.color.text,
};

export const productPriceStyle = {
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    fontSize: "0.875rem",
    color: LG.color.text,
    mr: 2,
    letterSpacing: "-0.02em",
    fontWeight: 600,
};

export const mainContainerStyle = {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: 3.75,
    p: { xs: 2, md: 4 },
    position: "relative",
    mt: { xs: 0, md: 0 },
};

export const leftColumnStyle = {
    flex: 2,
    pr: { md: "30px" },
};

export const rightColumnStyle = {
    flex: 1,
    position: "relative" as const,
    background: LG.color.surfaceStrong,
    backdropFilter: LG.blurStrong,
    WebkitBackdropFilter: LG.blurStrong,
    border: `1px solid ${LG.color.borderStrong}`,
    borderRadius: LG.radius.lg,
    boxShadow: LG.shadow.lg,
    p: 3,
};

// Legacy compat: these were replaced by LG-based styles above
export const getCouponFieldStyle = (_theme: any) => textFieldStyle;
export const getCouponButtonStyle = (_theme: any) => ({
    mt: 2,
    borderRadius: LG.radius.pill,
    borderColor: LG.color.border,
    color: LG.color.text,
    fontFamily: "inherit",
    fontWeight: 500,
    textTransform: "none" as const,
    "&:hover": {
        borderColor: LG.color.borderStrong,
        backgroundColor: LG.color.surface,
        color: LG.color.textSecondary,
    },
});
export const getCouponAppliedContainerStyleMobile = (_theme: any) => ({
    mt: 2,
    border: `1px solid ${LG.color.border}`,
    padding: "5px 15px",
});
export const getCouponAppliedContainerStyle = () => ({ mt: 2 });
export const getCouponDeleteButtonStyle = (_theme: any) => ({
    color: LG.color.text,
    "&:hover": { color: LG.color.textSecondary, opacity: 0.8 },
});

export const couponFieldStyle = textFieldStyle;
export const couponButtonStyle = getCouponButtonStyle({});
export const couponAppliedContainerStyle = getCouponAppliedContainerStyle();
export const couponAppliedContainerStyleMobile = getCouponAppliedContainerStyleMobile({});
export const couponDeleteButtonStyle = getCouponDeleteButtonStyle({});
export const couponSubmitButtonStyle = {
    background: LG.color.buttonDark,
    color: LG.color.buttonDarkText,
};
